import React, { Component } from 'react';
import { connect } from 'react-redux';
import NavigationBars from '../../components/HOC/withNavigationBars';
import actions from './duck/actions';
import roomGalleryActions from '../RoomGallery/duck/actions';
import { Loader, Breadcrumbs, colors, Button } from 'kangarootime-ui';
import RoomPhotoPercentages from './RoomPhotoPercentages';
import PhotosWaitingForApproval from './PhotosWaitingForApproval';
import MetricCard from './MetricCard';
import AllPhotosSentToday from './AllPhotosSentToday';
import { flatten } from '../../utils/array';

class Gallery extends Component {
  constructor (props) {
    super(props);

    this.state = {
      showPhotosSentTodayLightbox: false
    };
  }

  get showLoader () {
    const { roomPhotoPercentages, photosPendingApproval, fetchingGalleryInformation } = this.props;

    return fetchingGalleryInformation && roomPhotoPercentages.length === 0 && photosPendingApproval.length === 0;
  }

  get breadcrumbs () {
    return [
      { label: 'Dashboard', link: null }
    ];
  }

  componentDidMount = () => {
    this.props.getGalleryInformation();
    this.props.getGalleryInformationForRooms();
  }

  selectRoom = roomId => {
    this.props.history.push(`/gallery/room/${roomId}`, { roomId });
  }

  viewCenterGallery = () => {
    this.props.history.push(`/gallery/center/${this.props.currentCenterId}`, { centerId: this.props.currentCenterId });
  }

  /**
   * @returns {Object[]} - all photos that have been sent today
   */
  photosSentToday = () => {
    return flatten(Object.values(this.props.galleryInformationByRoom).map(roomArray =>
      flatten(roomArray.filter(
        child => child.photosTakenToday && child.photosTakenToday.length > 0).map(
        children => children.photosTakenToday
      )
      )
    ));
  }

  render () {
    const { roomPhotoPercentages, photosPendingApproval, totalPhotosTakenToday, requiresPhotoApproval } = this.props;

    return (
      <NavigationBars>
        <Loader loading={this.showLoader}>
          <div className='flex-columns flex-1'>
            <Breadcrumbs
              breadcrumbs={this.breadcrumbs}
            />
            <div className='flex-rows' style={{ marginBottom: 12 }}>
              <div className='flex-1'>
                <MetricCard
                  text='Photos sent TODAY'
                  number={totalPhotosTakenToday}
                  color={colors.shamrock}
                  onClick={() => this.setState({ showPhotosSentTodayLightbox: true })}
                />
              </div>
              <Button onClick={this.viewCenterGallery}>
                Go to Gallery
              </Button>
            </div>
            <RoomPhotoPercentages
              rooms={roomPhotoPercentages}
              selectRoom={this.selectRoom}
            />
            { requiresPhotoApproval
              ? <PhotosWaitingForApproval
                photos={photosPendingApproval}
              />
              : null
            }
          </div>
          <AllPhotosSentToday
            isOpen={this.state.showPhotosSentTodayLightbox}
            onClose={() => this.setState({ showPhotosSentTodayLightbox: false })}
            photos={this.photosSentToday()}
          />
        </Loader>
      </NavigationBars>
    );
  }
}

function mapStateToProps (state) {
  return {
    fetchingGalleryInformation: state.gallery.overview.fetchingGalleryInformation,
    roomPhotoPercentages: state.gallery.overview.metrics.roomPhotosPercentage,
    photosPendingApproval: state.gallery.overview.pending.photosPendingApproval,
    totalPhotosTakenToday: state.gallery.overview.metrics.numberOfPhotosSentToday,
    requiresPhotoApproval: state.gallery.overview.requiresPhotoApproval,
    galleryInformationByRoom: state.gallery.byRoom.roomGalleryInformation,
    currentCenterId: state.identity.centerId
  };
}

function mapDispatchToProps (dispatch) {
  return {
    getGalleryInformation: () => dispatch(actions.getCenterGalleryInformationRequest()),
    getGalleryInformationForRooms: () => dispatch(roomGalleryActions.getRoomGalleryRequest()),
    approvePhoto: photoId => dispatch(actions.approvePhotosRequest(photoId)),
    rejectPhoto: photoId => dispatch(actions.rejectPhotosRequest(photoId))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Gallery);
